import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _orderCardStyleMap;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { Dimensions, View, Text, TouchableOpacity, Image } from 'react-native'; // import { ProductCardProps } from '../../ProductCard/rn';

import { Button } from '../../Button/rn';
import { Order } from '../../Order/rn';
import { Popup } from '../../Popup/rn';
import { useLocale } from '../../LocaleProvider/rn';
import { BUYER_ORDER_LIST_TITLE_TEXT } from '../../../utils/constants';
import { ProductListTabs } from '../../ProductList/rn/ProductListTabs';
import moreOrderImage from '../../../assets/images/order_others.png';
import { getRealPx } from '../../../utils/rn/tools';
import styles from './styles';
import { ScrollType, TrackerScope, TrackerScrollView, useComponentTracking } from '../../../hooks/rn/useTracking';
import { ConfigContext } from '../../ConfigProvider/rn/context';
var BorderBottom = function BorderBottom() {
  return /*#__PURE__*/React.createElement(View, {
    style: {
      borderBottomWidth: 1,
      borderStyle: 'solid',
      borderBottomColor: 'rgba(0, 0, 0, 0.09)',
      transform: [{
        scaleY: getRealPx(1)
      }]
    }
  });
};
export var OrderCardType;
(function (OrderCardType) {
  OrderCardType[OrderCardType["oldCarousel"] = 0] = "oldCarousel";
  OrderCardType[OrderCardType["newCarousel"] = 1] = "newCarousel";
  OrderCardType[OrderCardType["bigCarousel"] = 2] = "bigCarousel";
  OrderCardType[OrderCardType["verticalList"] = 3] = "verticalList";
  OrderCardType[OrderCardType["twoRowCarousel"] = 4] = "twoRowCarousel";
  OrderCardType[OrderCardType["foodCardInList"] = 5] = "foodCardInList";
  OrderCardType[OrderCardType["orderWithCopy"] = 6] = "orderWithCopy";
  OrderCardType[OrderCardType["smallOrder"] = 7] = "smallOrder";
  OrderCardType[OrderCardType["foodCard"] = 8] = "foodCard";
  OrderCardType[OrderCardType["expeditedDelivery"] = 9] = "expeditedDelivery";
})(OrderCardType || (OrderCardType = {}));
export var orderCardStyleMap = (_orderCardStyleMap = {}, _defineProperty(_orderCardStyleMap, OrderCardType.oldCarousel, ''), _defineProperty(_orderCardStyleMap, OrderCardType.newCarousel, 'new-carousel'), _defineProperty(_orderCardStyleMap, OrderCardType.bigCarousel, 'big-carousel'), _defineProperty(_orderCardStyleMap, OrderCardType.verticalList, 'vertical-list'), _defineProperty(_orderCardStyleMap, OrderCardType.twoRowCarousel, 'two-row-carousel'), _defineProperty(_orderCardStyleMap, OrderCardType.foodCardInList, 'food-card-in-list'), _defineProperty(_orderCardStyleMap, OrderCardType.orderWithCopy, 'order-with-copy'), _defineProperty(_orderCardStyleMap, OrderCardType.smallOrder, 'small-order'), _defineProperty(_orderCardStyleMap, OrderCardType.foodCard, 'food-card'), _defineProperty(_orderCardStyleMap, OrderCardType.expeditedDelivery, 'expedited-delivery'), _orderCardStyleMap);
export var OrderList = function OrderList(props) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    showTime = _useState2[0],
    setShowTime = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPopup = _useState4[0],
    setShowPopup = _useState4[1];
  var containerRef = useRef(null);
  var context = useContext(ConfigContext);
  var reportConfig = context.reportConfig;
  var Modules = reportConfig.Modules,
    safeCallWithErrorReport = reportConfig.safeCallWithErrorReport;
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var showMoreOrderButton = props.showMoreOrderButton,
    _props$content = props.content,
    content = _props$content === void 0 ? [] : _props$content,
    loadMoreOrderText = props.loadMoreOrderText,
    selectOrderText = props.selectOrderText,
    tabs = props.tabs,
    userTypeTabs = props.userTypeTabs,
    onLoadMore = props.onLoadMore,
    defaultSelected = props.defaultSelected,
    _props$maxDisplay = props.maxDisplay,
    maxDisplay = _props$maxDisplay === void 0 ? 5 : _props$maxDisplay,
    itemText = props.itemText,
    itemsText = props.itemsText,
    panelTitleText = props.panelTitleText,
    showUserTypeTab = props.showUserTypeTab,
    _props$showScrollbar = props.showScrollbar,
    showScrollbar = _props$showScrollbar === void 0 ? false : _props$showScrollbar,
    _onButtonClick = props.onButtonClick,
    componentTrackingData = props.componentTrackingData,
    _props$showOrderId = props.showOrderId,
    showOrderId = _props$showOrderId === void 0 ? false : _props$showOrderId,
    _props$orderCardType = props.orderCardType,
    orderCardType = _props$orderCardType === void 0 ? OrderCardType.oldCarousel : _props$orderCardType,
    _props$showLoading = props.showLoading,
    showLoading = _props$showLoading === void 0 ? true : _props$showLoading,
    totalText = props.totalText,
    onClosePopup = props.onClosePopup,
    onOrderClick = props.onOrderClick,
    onShowMoreButtonClick = props.onShowMoreButtonClick,
    popupContentStyle = props.popupContentStyle,
    isProductCardNew = props.isProductCardNew,
    watchFn = props.watchFn;
  var _useComponentTracking = useComponentTracking(_objectSpread(_objectSpread({}, props), {}, {
      scope: TrackerScope.OrderList
    })),
    tracker = _useComponentTracking.tracker,
    result = _useComponentTracking.result;
  var moreOrderTracking = result.moreOrder,
    orderListTrackData = result.orderList,
    closePanelTrackingData = result.closePanel;
  var trackingData = componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.panelOrder;
  var handleMoreOrderClick = safeCallWithErrorReport(function () {
    setShowPopup(true);
    onShowMoreButtonClick === null || onShowMoreButtonClick === void 0 ? void 0 : onShowMoreButtonClick();
    (moreOrderTracking === null || moreOrderTracking === void 0 ? void 0 : moreOrderTracking.trackingClick) && tracker.click(moreOrderTracking.trackingClick);
    watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect('[OrderList] more btn click');
  }, Modules.OrderList);
  var renderOrder = function renderOrder(props) {
    var index = props.index;
    if (orderCardType !== OrderCardType.twoRowCarousel) {
      return index < maxDisplay && renderOrderItem(props);
    }
    return renderTwoRowCarousel(props);
  };
  var renderTwoRowCarousel = function renderTwoRowCarousel(props) {
    var index = props.index,
      order = props.order;
    if (index % 2 !== 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(View, {
      key: order.orderId
    }, renderOrderItem(props), index + 1 < content.length && renderOrderItem({
      order: content[index + 1],
      index: index + 1
    }));
  };
  var renderOrderItem = function renderOrderItem(props) {
    var order = props.order,
      index = props.index;
    var _useComponentTracking2 = useComponentTracking({
        componentTrackingData: componentTrackingData,
        componentData: {
          order: order,
          index: index
        },
        scope: TrackerScope.OrderList
      }),
      tracker = _useComponentTracking2.tracker,
      orderTracking = _useComponentTracking2.result.order;
    var handleCardClick = safeCallWithErrorReport(function () {
      onOrderClick === null || onOrderClick === void 0 ? void 0 : onOrderClick(order, index);
      (orderTracking === null || orderTracking === void 0 ? void 0 : orderTracking.trackingClick) && tracker.click(orderTracking.trackingClick);
      watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect('[OrderList] OrderCard click');
    }, Modules.OrderList);
    return /*#__PURE__*/React.createElement(View, orderTracking === null || orderTracking === void 0 ? void 0 : orderTracking.trackingImpressionProps, /*#__PURE__*/React.createElement(TouchableOpacity, {
      key: order.orderId,
      onPress: handleCardClick,
      style: [styles.orderItem, styles["orderItem-".concat(orderCardStyleMap[orderCardType])], orderCardType === OrderCardType.twoRowCarousel && index % 2 !== 0 && styles.twoRowCarouselBottomOrderItem],
      onLayout: function onLayout(e) {
        var _e$nativeEvent$layout = e.nativeEvent.layout,
          width = _e$nativeEvent$layout.width,
          height = _e$nativeEvent$layout.height;
        watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect("[OrderList] OrderCard render, width:".concat(width, " height:").concat(height));
      }
    }, /*#__PURE__*/React.createElement(Order, _extends({}, order, {
      allowSelectBtn: true,
      orderCardType: orderCardType,
      selectOrderText: selectOrderText,
      totalText: totalText,
      itemText: itemText,
      itemsText: itemsText,
      handleClick: handleCardClick
    })), orderCardType !== OrderCardType.verticalList && orderCardType !== OrderCardType.twoRowCarousel && /*#__PURE__*/React.createElement(Button, {
      action: order.action,
      text: selectOrderText,
      onClick: function onClick() {
        onOrderClick === null || onOrderClick === void 0 ? void 0 : onOrderClick(order, index);
        watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect('[OrderList] OrderCard btn click');
      },
      styles: {
        containerStyle: _objectSpread(_objectSpread({}, styles.selectOrderBtn), styles["selectOrderBtn-".concat(orderCardStyleMap[orderCardType])] || {})
      }
    }), orderCardType === OrderCardType.verticalList && /*#__PURE__*/React.createElement(BorderBottom, null)));
  };
  var renderMoreOrderBtn = function renderMoreOrderBtn(props) {
    var loadMoreOrderText = props.loadMoreOrderText;
    var shouldShowIcon = orderCardType !== OrderCardType.verticalList && orderCardType !== OrderCardType.twoRowCarousel;
    return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      onPress: handleMoreOrderClick,
      style: [styles.moreOrdersContainer, styles["moreOrdersContainer-".concat(orderCardStyleMap[orderCardType])]]
    }, moreOrderTracking === null || moreOrderTracking === void 0 ? void 0 : moreOrderTracking.trackingImpressionProps), shouldShowIcon && /*#__PURE__*/React.createElement(Image, {
      source: moreOrderImage,
      style: styles.moreOrdersImage
    }), /*#__PURE__*/React.createElement(Text, {
      style: [styles.moreOrdersText, styles["moreOrdersText-".concat(orderCardStyleMap[orderCardType])]]
    }, loadMoreOrderText));
  };
  var handleClosePopup = function handleClosePopup() {
    onClosePopup === null || onClosePopup === void 0 ? void 0 : onClosePopup();
    setShowPopup(false);
    watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect('[OrderList] Popup close event');
  };
  var orderScrollTrackHandler = function orderScrollTrackHandler() {
    if (orderListTrackData !== null && orderListTrackData !== void 0 && orderListTrackData.trackingScroll) {
      tracker.scroll(orderListTrackData.trackingScroll);
    }
  };
  useLayoutEffect(function () {
    if (showPopup) {
      setShowTime(Date.now());
      return;
    }
    if (!showPopup && showTime && closePanelTrackingData !== null && closePanelTrackingData !== void 0 && closePanelTrackingData.trackingClick) {
      var _closePanelTrackingDa;
      var _trackingData = _objectSpread(_objectSpread({}, (closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : (_closePanelTrackingDa = closePanelTrackingData.trackingClick) === null || _closePanelTrackingDa === void 0 ? void 0 : _closePanelTrackingDa.data) || {}), {}, {
        view_duration: Math.floor((Date.now() - showTime) / 1000)
      });
      tracker.click(_objectSpread(_objectSpread({}, closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : closePanelTrackingData.trackingClick), {}, {
        data: _trackingData
      }));
      setShowTime(0);
    }
  }, [showPopup]);
  return /*#__PURE__*/React.createElement(View, {
    ref: containerRef,
    style: [styles.container, styles["container-".concat(orderCardStyleMap[orderCardType])]],
    onLayout: function onLayout(e) {
      var _e$nativeEvent$layout2 = e.nativeEvent.layout,
        width = _e$nativeEvent$layout2.width,
        height = _e$nativeEvent$layout2.height;
      watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect("[OrderList] OrderList render, width:".concat(width, " height:").concat(height));
    }
  }, orderCardType === OrderCardType.verticalList ? /*#__PURE__*/React.createElement(View, {
    style: styles['orderList-vertical-list']
  }, content.map(function (order, index) {
    return renderOrder({
      order: order,
      index: index
    });
  }), showMoreOrderButton && renderMoreOrderBtn({
    loadMoreOrderText: loadMoreOrderText
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TrackerScrollView, {
    scope: TrackerScope.OrderList,
    scrollTrackOptions: {
      type: ScrollType.Horizontal,
      scrollCallback: orderScrollTrackHandler
    },
    horizontal: true,
    contentContainerStyle: styles.orderList,
    showsHorizontalScrollIndicator: showScrollbar
  }, content.map(function (order, index) {
    return renderOrder({
      order: order,
      index: index
    });
  }), showMoreOrderButton && orderCardType !== OrderCardType.twoRowCarousel && renderMoreOrderBtn({
    loadMoreOrderText: loadMoreOrderText
  })), showMoreOrderButton && orderCardType === OrderCardType.twoRowCarousel && renderMoreOrderBtn({
    loadMoreOrderText: loadMoreOrderText
  })), /*#__PURE__*/React.createElement(Popup, {
    title: panelTitleText || trans(BUYER_ORDER_LIST_TITLE_TEXT),
    showCloseIcon: true,
    active: showPopup,
    onClose: function onClose() {
      return handleClosePopup();
    },
    titleStyle: {
      textAlign: 'center'
    },
    contentContainerStyle: {
      height: Dimensions.get('window').height * 0.8
    },
    contentStyle: [{
      padding: 0
    }, popupContentStyle],
    contentScrollable: false,
    delayBeforeContentShow: 300
  }, /*#__PURE__*/React.createElement(ProductListTabs, {
    tabs: tabs,
    userTypeTabs: userTypeTabs,
    onLoadMore: onLoadMore,
    selectOrderText: selectOrderText,
    defaultSelected: defaultSelected,
    itemText: itemText,
    itemsText: itemsText,
    showOrderId: showOrderId,
    showUserTypeTab: showUserTypeTab,
    onButtonClick: function onButtonClick(params) {
      _onButtonClick === null || _onButtonClick === void 0 ? void 0 : _onButtonClick(params);
      setShowPopup(false);
    },
    trackingData: trackingData,
    componentTrackingData: componentTrackingData,
    showLoading: showLoading,
    isProductCardNew: isProductCardNew,
    watchFn: watchFn
  })));
};
export default OrderList;